// Third party libraries
import * as $ from 'jquery';

export default {
    name: 'ModalMultipleBrands',
    props: {
        modalContent: {
            type: Object,
            default: null
        }
    },
    beforeDestroy() {
        this.hideModal();
    },
    methods: {
        show() {
            $(this.$refs.modalMultipleBrands).modal('show');
        },
        hideModal() {
            $(this.$refs.modalMultipleBrands).modal('hide');
        }
    }
}